import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorService } from 'src/app/_core/_services/behavior.service';
import { EventsService } from 'src/app/_core/_services/events.service';
import { ThemeService } from 'src/app/_core/_services/theme.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

  @Input('showNav') public showNav_: boolean = true;

  public User$: any = {};
  public pagePath: string;
  
  public LightTheme$: boolean;

  constructor(
    private router: Router,
    private beh: BehaviorService,
    private themeSvc: ThemeService,
    private event: EventsService
  ) {
    this.themeSvc.lightTheme.subscribe(l => { this.LightTheme$ = l });
    this.beh.UserAccount.subscribe(u => { this.User$ = u });
    
    this.pagePath = this.router.url.replace('/', '').split('/')[0];
    this.router.events.subscribe(events => { events instanceof NavigationEnd && (this.pagePath = events.urlAfterRedirects.replace('/', '').split('/')[0]) });
  }

  ngOnInit(): void { }

  public navigate(path: string[]) {
    this.router.navigate(path, { queryParamsHandling: 'merge' });
  }

  public resgistEvent(et) {
    this.event.eventStart({ eventType: et, eventCategory: 'CLICK' });
  }

}
